import React from 'react';

export function ContractSigningRestrictions() {
  return (
    <div className="card shadow-sm">
      <div className="card-body d-flex flex-column flex-md-row gap-2">
        <img className="align-self-center" src="/static/img/illustrations/quality-check.svg" width={88} alt="" />
        <ul className="fs-sm text-subtitle mb-0">
          <li>
            El peso máximo que soporta la carga es de
            {' '}
            <span className="fw-bold">10Mb por cada archivo</span>
            .
          </li>
          <li>
            El nombre del archivo debe tener
            {' '}
            <span className="fw-bold">máximo 256 caracteres</span>
            .
          </li>
          <li>
            Puedes cargar un
            {' '}
            <span className="fw-bold">máximo de 10 archivos</span>
            {' '}
            al mismo tiempo.
          </li>
          <li>
            El formato del archivo debe ser en
            {' '}
            <span className="fw-bold">PDF sin incluir imágenes</span>
            .
          </li>
        </ul>
      </div>
    </div>
  );
}

export function DocumentsUploaderDocumentRestrictions() {
  return (
    <div
      className="alert alert-info alert-dismissible fade show mb-0"
      role="alert"
    >
      <div>
        <span className="fw-bold">Recuerda que los documentos que puedes firmar son:</span>
        {' '}
        SAAPV, Solicitud de inversión, Contrato APV Prime, Anexo Comisiones,
        {' '}
        Contrato General de Fondos, Encuesta de Perfil de Inversionista.
        <br />
        <span className="fw-bold">No puedes firmar:</span>
        {' '}
        PAC Solicitud de retiro.
      </div>
      <button className="btn-close" type="button" data-bs-dismiss="alert" aria-label="Cerrar" />
    </div>
  );
}

export function ContractSigningSignerOrderReminder() {
  return (
    <div
      className="alert alert-info alert-dismissible fade show"
      role="alert"
    >
      <div className="fs-sm">
        <b>IMPORTANTE:</b>
        {' '}
        Asegúrate de ingresar
        {' '}
        <b>correctamente los RUTs</b>
        {' '}
        de la
        {' '}
        <b>empresa y los apoderados.</b>
        {' '}
        Ten en cuenta que el orden en que los ingreses determinará el orden
        {' '}
        que apoderados deberán firmar.
      </div>
    </div>
  );
}
